(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["hero"] && !Shopify.designMode) return;
  try {
    
if(!customElements.get('vexllo-sculpture-world')){
customElements.define('vexllo-sculpture-world',class extends HTMLElement{
connectedCallback(){
this.abort=new AbortController();this.reduced=matchMedia('(prefers-reduced-motion: reduce)');
const opts={signal:this.abort.signal};
this.addEventListener('pointermove',event=>{
if(this.reduced.matches||event.target.closest('a'))return;
const box=this.getBoundingClientRect();
const x=Math.max(0,Math.min(1,(event.clientX-box.left)/box.width));
const y=Math.max(0,Math.min(1,(event.clientY-box.top)/box.height));
this.style.setProperty('--sculpture-y',(x*2.4-1.2)+'deg');
this.style.setProperty('--sculpture-x',(1-y*2)+'deg');
this.style.setProperty('--sculpture-light',(x*100)+'%');
},opts);
['pointerleave','pointerup','pointercancel'].forEach(name=>this.addEventListener(name,()=>this.reset(),opts));
this.reduced.addEventListener('change',()=>this.reset(),opts);
}
reset(){this.style.setProperty('--sculpture-x','0deg');this.style.setProperty('--sculpture-y','0deg');}
disconnectedCallback(){this.abort?.abort();}
});
}

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["main-collection"]) return;
  try {
    
  const url = new URL(window.location.href);
  if (url.hash) {
    document.addEventListener(
      'DOMContentLoaded',
      () => {
        const card = document.getElementById(url.hash.slice(1));
        if (card) {
          card.scrollIntoView({ behavior: 'instant' });
        }
      },
      { once: true }
    );
  }

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["vexllo-detail-world"] && !Shopify.designMode) return;
  try {
    
if(!customElements.get('vexllo-detail-world')){
customElements.define('vexllo-detail-world',class extends HTMLElement{
connectedCallback(){
this.abort=new AbortController();this.reduced=matchMedia('(prefers-reduced-motion: reduce)');
const opts={signal:this.abort.signal};
this.addEventListener('pointermove',event=>{
if(this.reduced.matches||event.target.closest('a'))return;
const box=this.getBoundingClientRect();
const x=Math.max(0,Math.min(1,(event.clientX-box.left)/box.width));
const y=Math.max(0,Math.min(1,(event.clientY-box.top)/box.height));
this.style.setProperty('--detail-y',(x*1.8-.9)+'deg');
this.style.setProperty('--detail-x',(.7-y*1.4)+'deg');
},opts);
['pointerleave','pointerup','pointercancel'].forEach(name=>this.addEventListener(name,()=>{
this.style.setProperty('--detail-x','0deg');this.style.setProperty('--detail-y','0deg');
},opts));
}
disconnectedCallback(){this.abort?.abort();}
});
}

  } catch(e) { console.error(e); }
})();
})();
